/** Grade EWSS persisté après une partie (réussite ou échec). */
export function getEwssGradeFromGameEntry(game) {
  if (game?.insufficientData === true) return null;
  if (typeof game?.gradeAfter === "string" && game.gradeAfter.trim()) {
    return game.gradeAfter.trim();
  }
  return null;
}

/** Grades EWSS pour la ligne d'évolution — uniquement les snapshots persistés (gradeAfter). */
export function buildEwssEvolutionGrades(gamesNewestFirst) {
  if (!Array.isArray(gamesNewestFirst) || !gamesNewestFirst.length) return [];

  return gamesNewestFirst.map((game) => getEwssGradeFromGameEntry(game) ?? "—");
}
